module.exports = __webpack_public_path__ + "static/media/spinner.182d2cfc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spinner.svg
// module id = 296
// module chunks = 17